import React, { useState, useEffect, useRef, Fragment } from 'react';

import _, { values } from 'lodash';
import cx from 'classnames';

import Fonts from '../../../../fonts';
import Content from '../../../../widgets/core/content';
import { useParentWidgetSelectorForType } from '../../../../widgets/core/hooks';

import { CONTENT } from '../../../../../constants/widgetTypes';

import { Dropdown } from 'react-bootstrap';
import Truncate from "react-truncate";
import Tooltip from './../../../../../components/Tooltip';

import styles from './filterDropdown.module.scss';

const FilterDropdownComponent = ({ className, widgetProps, breakpoint, filterContent, alignment }) => {

  const wrapperStyles = dropdownButtonWrapperStyles(widgetProps, alignment, breakpoint);

  return (
    <div style={wrapperStyles} className={cx(className, styles.dropdownContainer)}>
      {
        (filterContent && _.size(filterContent) == 1) &&
        (_.compact(filterContent) || []).map((filter) => {

          const options = [{
            id: 'all',
            value: 'All'
          }, ...filter.options];

          return options.map((option, index) => {
            return (
              <ButtonTab
                filter={filter}
                option={option}
                widgetProps={widgetProps}
                breakpoint={breakpoint}
                index={index}
              />
            )
          })
        })
      }
      {
        (filterContent && _.size(filterContent) > 1) &&
        (_.compact(filterContent) || []).map((filter, index) => {
          return (
            <Dropdown>
              <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components"
                widgetProps={widgetProps}
                breakpoint={breakpoint}
                index={index}
                filter={filter}
                contentLength={filterContent.length}>
                {filter.name}
              </Dropdown.Toggle>

              <Dropdown.Menu as={CustomMenu}>
                <DropdownMenu widgetProps={widgetProps} filter={filter} />
              </Dropdown.Menu>
            </Dropdown>
          )
        })
      }

      {filterContent && _.size(filterContent) > 1 &&
        <RenderResetButton widgetProps={widgetProps} breakpoint={breakpoint}/>
      }
    </div>
  )
}

const RenderResetButton = ({ widgetProps, breakpoint }) => {

  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  const filters = _.get(contentWidget, 'filters', []);

  if (!filters || _.size(filters) == 0) {
    return null;
  }

  return (
    <Dropdown>
      <Dropdown.Toggle as={ResetButton} widgetProps={widgetProps}
        breakpoint={breakpoint} />
    </Dropdown>
  )
}

const ButtonTab = ({ filter, option, widgetProps, breakpoint }) => {

  const [state, setState] = useState({
    buttonStyle: {},
    hover: false
  })

  const contentContext = React.useContext(Content.Context);
  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);

  const filters = _.get(contentWidget, 'filters', []);
  const selectedFilter = filters.find(item => item.property.fieldId === filter.id);
  const selectedValue = selectedFilter && selectedFilter.value ? selectedFilter.value[0] : null;
  const selected = (filter.options || []).find(item => item.id === selectedValue) || { id: "all", option: "All" };

  const hoverStyle = getStyles(widgetProps, breakpoint, 'hover');
  const buttonTabStyle = selected.id == option.id ? hoverStyle : state.buttonStyle;

  useEffect(() => {
    const regularBtnStyle = getStyles(widgetProps, breakpoint, 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: regularBtnStyle,
      }
    })
  }, [breakpoint, widgetProps]);

  useEffect(() => {
    let updatedStyle = getStyles(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: updatedStyle,
      }
    })
  }, [state.hover])

  const handleOnMouseOver = (hover) => {
    setState((state) => {
      return {
        ...state,
        hover: hover
      }
    })
  }

  const handleClick = (e) => {
    e.stopPropagation();

    var request = {
      property: {
        type: "CUSTOM_FIELD",
        fieldId: filter.id
      },
      operator: "IS",
      value: null
    }

    if (option && option.id !== 'all') {
      request = {
        ...request,
        value: [option.id]
      }
    }

    contentContext.updateFiltersInContenGrid(contentWidget.uid, request);
  }

  return (
    <div
      onMouseLeave={() => handleOnMouseOver(false)}
      onMouseEnter={() => handleOnMouseOver(true)}
      className={cx(styles.dropdownButton)}
      style={buttonTabStyle}
      onClick={handleClick}>
      <div className={cx(styles.filterMenuItem)}>
        <TruncatedTextWithTooltip content={option.value} className={styles.label} maxWidth={300} placement='top'/>
      </div>
    </div>
  )
};

const DropdownMenu = ({ widgetProps, filter }) => {

  const options = [{
    id: 'all',
    value: 'All'
  }, ...filter.options];

  return (
    <Fragment>
      {
        (options || []).map((option, index) => {
          return (
            <Dropdown.Item as={DropdownOption} key={index}
              widgetProps={widgetProps}
              breakpoint="desktop"
              filter={filter}
              option={option}
              index={index} />
          )
        })
      }
    </Fragment>
  )
}

const CustomToggle = React.forwardRef(({ onClick, index, contentLength, breakpoint, widgetProps, filter }, ref) => {
  const [state, setState] = useState({
    buttonStyle: {},
    hover: false
  })

  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  const filters = _.get(contentWidget, 'filters', []);
  const selectedFilter = filters.find(item => item.property.fieldId === filter.id);
  const selecetdValue = selectedFilter && selectedFilter.value ? selectedFilter.value[0] : null;
  const selected = (filter.options || []).find(item => item.id === selecetdValue);

  useEffect(() => {
    const activeButtonStyle = getStyles(widgetProps, breakpoint, 'regular');
    setState((state) => {
      return {
        ...state,
        buttonStyle: activeButtonStyle,
      }
    })

  }, [breakpoint, widgetProps]);

  useEffect(() => {
    let updatedStyle = getStyles(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: updatedStyle,
      }
    })
  }, [state.hover])

  const handleOnMouseOver = (hover) => {
    setState((state) => {
      return {
        ...state,
        hover: hover
      }
    })
  }

  return (
    <div
      onMouseLeave={() => handleOnMouseOver(false)}
      onMouseEnter={() => handleOnMouseOver(true)}
      className={cx(styles.dropdownButton, { [styles.lastButton]: index === contentLength - 1 && filters.length === 0 })}
      ref={ref}
      style={state.buttonStyle}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div className={cx(styles.filterMenuItem, {
        [styles.selected]: selected != null
      })}>
        <TruncatedTextWithTooltip content={filter.name} className={styles.label} maxWidth={300} placement='top'/>
        <TruncatedTextWithTooltip content={_.get(selected, 'value')} className={styles.value} maxWidth={300} placement='top'/>
      </div>
      <i className={cx('cleverstory-drop-down', styles.dropDownIcon, { [styles.showDropdown]: false })} />
    </div>
  )
});

const ResetButton = ({ breakpoint, widgetProps }) => {
  const [state, setState] = useState({
    buttonStyle: {},
    hover: false
  })

  const contentContext = React.useContext(Content.Context);

  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  const filters = _.get(contentWidget, 'filters', []);

  const handleOnMouseOver = (hover) => {
    setState((state) => {
      return {
        ...state,
        hover: hover
      }
    })
  }

  useEffect(() => {
    let updatedStyle = getStyles(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: updatedStyle,
      }
    })
  }, [state.hover]);

  const handleResetClick = () => {
    contentContext.resetFiltersInContenGrid(contentWidget.uid);
  }

  if (!filters || filters.length === 0) {
    return null;
  }

  return (
    <div
      onMouseLeave={() => handleOnMouseOver(false)}
      onMouseEnter={() => handleOnMouseOver(true)}
      className={cx(styles.dropdownButton, styles.lastButton)}
      style={state.buttonStyle}
      onClick={(e) => {
        e.preventDefault();
        handleResetClick(e);
      }}
    >
      <div className={cx(styles.filterMenuItem)}>
        <div className={styles.label}>Reset</div>
      </div>
    </div>
  )
}

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = useState('');
    return (
      <div
        ref={ref}
        className={cx(className, styles.dropdownMenu)}
        aria-labelledby={labeledBy}
      >
        <div className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value),
          )}
        </div>
      </div>
    );
  },
);

const DropdownOption = ({ filter, option, index, widgetProps, breakpoint }) => {
  const contentContext = React.useContext(Content.Context);

  const [subFilterMenuStyle, setSubFilterMenuStyle] = useState(getDropDownStyles(widgetProps, 'regular', breakpoint))
  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);

  const handleSubMenuHover = (active) => {
    const updatedStyle = getDropDownStyles(widgetProps, active, breakpoint);

    setSubFilterMenuStyle(updatedStyle)
  }

  const handleClick = (e) => {
    e.stopPropagation();

    var request = {
      property: {
        type: "CUSTOM_FIELD",
        fieldId: filter.id
      },
      operator: "IS",
      value: null
    }

    if (option && option.id !== 'all') {
      request = {
        ...request,
        value: [option.id]
      }
    }

    contentContext.updateFiltersInContenGrid(contentWidget.uid, request);

    document.body.click();
  }

  return (
    <div
      style={subFilterMenuStyle}
      key={index}
      onMouseLeave={() => handleSubMenuHover('regular')}
      onMouseEnter={() => handleSubMenuHover('hover')}
      onClick={handleClick}
      className={styles.dropdownItem}
    >
      <TruncatedTextWithTooltip content={option.value} maxWidth={300} placement='top'/>
    </div>
  )
}

const filterDropdownEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint', 'filterContent', 'active', 'alignment'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const FilterDropdown = React.memo(FilterDropdownComponent, filterDropdownEquals);

/**
 * Generate Styles
*/
function getDropDownStyles(widgetProps, active, breakpoint) {
  var styles = {};

  if (!widgetProps) {
    return styles;
  }

  const defaultProperties = _.get(widgetProps, `properties.desktop`);
  const defaultStyles = _.get(defaultProperties, `regular.filterStyles`, {});

  //font-color
  const colorRgb = _.get(defaultProperties, `${active}.dropdownColor`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    color: color
  }

  //background
  const backgroundRgb = _.get(defaultProperties, `${active}.dropdownBackground`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, ${backgroundRgb.a})`;
  }

  styles['backgroundColor'] = background;


  const font = _.get(defaultStyles, 'font', {});

  //font-family
  const fontFamily = _.get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: fontFamily
    }
  }

  //line Height
  const layoutHeight = _.get(defaultProperties, 'layout.height');
  if (layoutHeight) {
    styles['lineHeight'] = layoutHeight;
  }

  //font-style
  const bold = _.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = _.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = _.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //line spacing
  const lineSpacingString = _.get(defaultProperties, 'regular.filterStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }

  //Letter Spacing
  const letterSpacingString = _.get(defaultProperties, 'regular.filterStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //font-size
  const fontSizeString = breakpoint === 'desktop' ? _.get(defaultProperties, `regular.filterStyles.font.fontSize`, null) : 14;
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;
  styles['justifyContent'] = 'center';
  styles['textAlign'] = 'center';


  //border
  const border = _.get(defaultProperties, `${active}.dropdownBorder`, {});
  const borderColor = _.get(border, `color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  // spacing & padding
  const spacing = _.get(defaultProperties, 'padding');
  const horizontalPadding = _.get(defaultProperties, 'itemHorizontalPadding');
  const verticalPadding = _.get(defaultProperties, 'itemVerticalPadding');

  styles = {
    ...styles,
    paddingLeft: `${horizontalPadding}px`,
    paddingRight: `${horizontalPadding}px`,
    paddingTop: `${verticalPadding}px`,
    paddingBottom: `${verticalPadding}px`
  }

  return styles;
}

function dropdownButtonWrapperStyles(widget, alignment, breakpoint) {
  var styles = {};

  if (!widget) {
    return styles;
  }

  const defaultProperties = _.get(widget, `properties.desktop`, {});
  // spacing & padding
  const spacing = _.get(defaultProperties, 'padding');

  // Apply default styles
  styles = {
    ...styles,
    gridColumnGap: `${spacing}px`,
  };

  // Apply alignment styles only if breakpoint is 'mobile'
  if (breakpoint === 'mobile') {
    styles = {
      ...styles,
      ...alignment,
    };
  }

  return styles;
}

function getStyles(widget, breakpoint, active) {
  var styles = {};

  if (!widget) {
    return styles;
  }

  const defaultProperties = _.get(widget, `properties.desktop`, {});
  const deviceProperties = _.get(widget, `properties.${breakpoint}`, {});
  const defaultStyles = _.get(defaultProperties, `regular.filterStyles`, {});

  //font-color
  const colorRgb = _.get(defaultProperties, `${active}.filterStyles.font.color`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    color: color
  }

  //background
  const backgroundRgb = _.get(defaultProperties, `${active}.filterStyles.background`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, ${backgroundRgb.a})`;
  }

  styles['backgroundColor'] = background;

  const font = _.get(defaultStyles, 'font', {});

  //font-family
  const fontFamily = _.get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: fontFamily
    }
  }

  //font-size
  const fontSizeString = _.get(deviceProperties, 'regular.filterStyles.font.fontSize', null);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;

  //Letter Spacing
  const letterSpacingString = _.get(deviceProperties, 'regular.filterStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //line Height
  const layoutHeight = _.get(deviceProperties, 'layout.height');
  if (layoutHeight && breakpoint === 'desktop') {
    styles['lineHeight'] = layoutHeight;
  }

  //line spacing
  const lineSpacingString = _.get(deviceProperties, 'regular.filterStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }


  //font-style
  const bold = _.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = _.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = _.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //border
  const border = _.get(defaultProperties, `${active}.filterStyles.border`, {});
  const borderColor = _.get(defaultProperties, `${active}.filterStyles.border.color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  // spacing & padding
  const spacing = _.get(defaultProperties, 'padding');
  const horizontalPadding = _.get(defaultProperties, 'itemHorizontalPadding');
  const verticalPadding = _.get(defaultProperties, 'itemVerticalPadding');

  styles = {
    ...styles,
    paddingLeft: `${horizontalPadding}px`,
    paddingRight: `${horizontalPadding}px`,
    paddingTop: `${verticalPadding}px`,
    paddingBottom: `${verticalPadding}px`
  }


  //alignment
  const alignment = _.get(deviceProperties, 'alignment', {});

  var position = _.get(alignment, 'position', 'center');
  styles['justifyContent'] = position;
  styles['textAlign'] = position;

  var margin = _.get(alignment, 'margin', 0);
  if (position === 'left') {
    styles = {
      ...styles,
      paddingLeft: `${margin}px`
    }
  } else if (position === 'right') {
    styles = {
      ...styles,
      paddingRight: `${margin}px`
    }
  }

  return styles;
}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  return color;
}

export function getBorderStyles(value, colorRgb) {
  if (!value) {
    return null;
  }

  var styles = {};
  const topLeft = _.get(value, 'radius.topLeft', null);
  const topRight = _.get(value, 'radius.topRight', null);
  const bottomLeft = _.get(value, 'radius.bottomLeft', null);
  const bottomRight = _.get(value, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  var color = 'transparent';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  styles['borderColor'] = color;

  const borderWidthString = _.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';

  styles['borderWidth'] = borderWidget;

  return styles;
}

const TruncatedTextWithTooltip = ({ content, className, maxWidth = 200, placement = "top" }) => {
  const [tooltip, setTooltip] = useState(false);

  const handleTooltip = (isTruncated) => {
    setTooltip(isTruncated)
  }

  return (
    <Tooltip placement={placement} disabled={!tooltip} content={content}>
      <div className={className}>
        <Truncate lines={1} width={maxWidth} ellipsis="..." onTruncate={handleTooltip}>
          {content}
        </Truncate>
      </div>
    </Tooltip>
  )
}
